import React from "react";

// CloudScore-style KPI: white card, subtle border, label small caps,
// big value, soft colored icon tile on the right.
const TONE = {
  primary: { fg: "#00579e", bg: "#dbeafe" },
  success: { fg: "#15803d", bg: "#dcfce7" },
  warning: { fg: "#9a3412", bg: "#ffedd5" },
  danger: { fg: "#b91c1c", bg: "#fee2e2" },
  neutral: { fg: "#6d28d9", bg: "#ede9fe" },
  teal: { fg: "#0e7490", bg: "#cffafe" },
};

export default function KpiCard({
  label,
  value,
  sublabel,
  icon: Icon,
  tone = "primary",
  hint,
  testId,
}) {
  const c = TONE[tone] || TONE.primary;
  return (
    <div
      data-testid={testId}
      className="cs-card p-5 flex items-start justify-between gap-3"
    >
      <div className="min-w-0 flex-1">
        <div className="text-[10px] uppercase tracking-[0.16em] font-medium text-muted-foreground mb-2">
          {label}
        </div>
        <div className="cs-kpi-value text-[28px] leading-tight text-foreground" data-testid={`${testId}-value`}>
          {value}
        </div>
        {sublabel && (
          <div className="text-xs text-muted-foreground mt-1.5 break-words" title={typeof sublabel === "string" ? sublabel : undefined}>{sublabel}</div>
        )}
        {hint && (
          <div className="text-[10px] cs-mono text-muted-foreground mt-1">{hint}</div>
        )}
      </div>
      {Icon && (
        <div
          className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
          style={{ background: c.bg, color: c.fg }}
        >
          <Icon className="w-5 h-5" strokeWidth={2} />
        </div>
      )}
    </div>
  );
}
